import React from 'react'
import { FcWorkflow } from 'react-icons/fc'
import TechnologyServicePage from '../components/TechnologyServicePage'

const capabilities = [
    { title: 'ICT Consulting', description: 'Practical advisory for technology decisions, planning, and execution.' },
    { title: 'Enterprise Architecture', description: 'Structure systems, data, and processes for long-term scale.' },
    { title: 'Solution Architecture', description: 'Design clear technical blueprints for new platforms and integrations.' },
    { title: 'Project Management', description: 'Coordinate delivery, timelines, stakeholders, and implementation risks.' },
    { title: 'Programme Management', description: 'Manage multi-project initiatives with consistent governance.' },
    { title: 'Business Analysis', description: 'Translate operational needs into clear product and system requirements.' },
    { title: 'Quality Assurance', description: 'Validate solutions before rollout with structured testing and review.' },
    { title: 'Technology Audits', description: 'Assess systems, risks, gaps, and opportunities for improvement.' },
    { title: 'Capacity Building', description: 'Train teams to use and manage technology confidently.' }
]

const ProfessionalServices = () => (
    <TechnologyServicePage
        badge="Professional Services"
        title="Expert guidance for planning, delivery, and technology governance."
        description="We provide ICT consulting, architecture, project management, audits, quality assurance, and capacity building for successful technology initiatives."
        metaDescription="Professional ICT consulting, enterprise architecture, solution architecture, project management, quality assurance, audits, and training."
        icon={<FcWorkflow className="text-sm" />}
        capabilities={capabilities}
        outcomes={[
            { title: 'Better decisions', description: 'Advisory that clarifies technology choices and priorities.' },
            { title: 'Controlled delivery', description: 'Governed execution across projects, programmes, and stakeholders.' },
            { title: 'Stronger teams', description: 'Training and capacity building that supports long-term ownership.' }
        ]}
        highlights={[
            { title: 'Plan', description: 'Shape strategy, architecture, procurement, and requirements.' },
            { title: 'Deliver', description: 'Manage projects, programmes, quality assurance, and risks.' },
            { title: 'Strengthen', description: 'Audit systems and build team capability for sustainable operations.' }
        ]}
        cta={{
            eyebrow: 'Professional expertise',
            title: 'Bring structure and confidence to your next technology project.',
            description: 'From architecture to delivery, we help teams make progress with less uncertainty.'
        }}
    />
)

export default ProfessionalServices
